
import { Component, Mixins, Emit, Prop } from "vue-property-decorator";
import { CommonTabMixin } from ".";
import { ButtonInfo } from "../../../../../domain/workflow/items";
import { WorkflowDocumentKinds } from "../../../../../domain/workflow/kinds";
import { DomainRegistry } from "../../../../../domain";
import { WorkflowDocumentSaveResult } from "../../../../../domain/workflow/document";
import WorkflowActionDialog from "../../../dialogs/WorkflowActionDialog.vue";
import WorkflowActionConfirmDialog from "../../../dialogs/WorkflowActionConfirmDialog.vue";

@Component({
})
export default class RequestSheetTabMixin extends Mixins(CommonTabMixin) {
  @Prop()
  workflowActionDialog: WorkflowActionDialog;

  @Prop()
  workflowActionConfirmDialog: WorkflowActionConfirmDialog;

  data(): any {
    return {
      isRequestSheetDeleting: false,
    };
  }
  isRequestSheetDeleting: boolean;

  // --------------文書作成依頼書用ボタン------------------------

  get showRequestSheetPermission(): ButtonInfo {
    return this.permissions ? this.permissions.requestSheetShow : null;
  }

  get permittedShowRequestSheet(): boolean {
    return this.showRequestSheetPermission ? this.showRequestSheetPermission.isPermitted : false;
  }

  get createRequestSheetPermission(): ButtonInfo {
    return this.permissions ? this.permissions.requestSheetCreate : null;
  }

  get permittedCreateRequestSheet(): boolean {
    return this.createRequestSheetPermission ? this.createRequestSheetPermission.isPermitted : false;
  }

  get editRequestSheetPermission(): ButtonInfo {
    return this.permissions ? this.permissions.requestSheetEdit : null;
  }

  get permittedEditRequestSheet(): boolean {
    return this.editRequestSheetPermission ? this.editRequestSheetPermission.isPermitted : false;
  }

  get deleteRequestSheetPermission(): ButtonInfo {
    return this.permissions ? this.permissions.requestSheetDelete : null;
  }

  get permittedDeleteRequestSheet(): boolean {
    return this.deleteRequestSheetPermission ? this.deleteRequestSheetPermission.isPermitted : false;
  }

  get hasRequestSheetReferenceFiles(): boolean {
    return this.requestSheetReferenceFiles && this.requestSheetReferenceFiles.length > 0;
  }

  get permittedShowRequestSheetReferenceFiles(): boolean {
    return this.permittedCreateRequestSheet || this.permittedEditRequestSheet;
  }

  // --------------プロパティ-------------------------------

  get formatPreviewSource(): string {
    const requestSheetFormat = (this.requestSheetFormats.length === 1) ? this.requestSheetFormats[0] : null;
    return (requestSheetFormat && requestSheetFormat.previewSource)
      ? requestSheetFormat.previewSource.source
      : "";
  }

  // 閲覧・記載制限がかかるようになる
  // 閲覧権限がない場合はプレビュー出さない
  get documentPreviewSource(): string {
    if (this.requestSheetDocument && this.requestSheetDocumentReadable) {
      if (this.requestSheetDocument.previewSource) {
        return this.requestSheetDocument.previewSource.source;
      }
    }

    return "";
  }

  // ---------------メソッド--------------------------------------

  // 文書参照
  showDocument(): void {
    const param: any = {
      documentKind: WorkflowDocumentKinds.RequestSheet,
      receptionId: this.reception.id,
      patientNo: this.reception.patientInfo.patient.id,
      documentId: this.requestSheetDocument.id,
      isReadRestrictionAlreadyHandled: true,  // 依頼書を閲覧制限するケースはないものと想定している
    };

    this.$openWindow("/ShowWorkflowDocument", param);
  }

  // 文書作成
  createDocument(): void {
    this.$commonDialogs.format.selector.show(this.requestSheetFormats)
    .then(format => {
      if (!format) { return; }
      const param: any = {
        documentKind: WorkflowDocumentKinds.RequestSheet,
        receptionId: this.reception.id,
        formatId: format.id,
        patientNo: this.reception.patientInfo.patient.id
      };
      this.$openWindow("/EditNewWorkflowDocument", param);
    })
    .catch(e => {
      this.$error(
        this.$wording.format.name + "選択失敗",
        this.$wording.format.name + "の選択中にエラーが発生しました。",
        e,
      );
    });
  }

  // 文書編集
  editDocument(): void {
    const param: any = {
      documentKind: WorkflowDocumentKinds.RequestSheet,
      receptionId: this.reception.id,
      patientNo: this.reception.patientInfo.patient.id,
      documentId: this.requestSheetDocument.id,
      isReadRestrictionAlreadyHandled: true.toString(),  // 依頼書を閲覧制限するケースはないものと想定している
    };

    this.$openWindow("/EditWorkflowDocument", param);
  }

  // 文書削除
  async deleteDocument(): Promise<void> {
    if (this.requestSheetDocument) {
      const repository = DomainRegistry.document.getDocumentRepository();
      const editTokens = await repository.getCurrentEditTokens(this.requestSheetDocument.id);
      if (editTokens && 0 < editTokens.length) {
        const ret = await this.workflowActionConfirmDialog.show(editTokens, this.deleteRequestSheetPermission.buttonName, this.deleteRequestSheetPermission.confirmMessage);
        if (!ret) { return; }
      }
    }

    this.confirmToDeleteDocument()
    .then(isConfirmed => {
      if (!isConfirmed) { return; }

      this.isRequestSheetDeleting = true;
      this.deleteRequestSheetDocument()
      .then(result => {
        if (result.success) {
          this.$success(this.deleteRequestSheetPermission.buttonName, result.message);
          this.requestSheetDeleted();
        } else {
          this.$error(this.deleteRequestSheetPermission.buttonName, result.reason);
        }
      })
      .catch(e => {
        this.showRequestErrorMessage("エラー", "処理の実行に失敗しました。", e);
      })
      .finally(() => {
        this.isRequestSheetDeleting = false;
      });
    });
  }

  private async confirmToDeleteDocument(): Promise<boolean> {
    const result = await this.workflowActionDialog.show({
      actionPermission: this.deleteRequestSheetPermission,
    });
    return result.isConfirmed;
  }

  private async deleteRequestSheetDocument(): Promise<WorkflowDocumentSaveResult> {
    const repository = DomainRegistry.workflow.getWorkflowRepository();
    return repository.deleteRequestSheetDocument(this.reception.id, this.reception.patientInfo.patient.id, this.requestSheetDocument.id);
  }

  @Emit()
  requestSheetDeleted(): void {}
}
